/* istanbul ignore file */

import('./bootstrap');
